import React from 'react'
import { colors } from '../../theme'

function SearchPlus() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill={colors.primaryText}
        fillRule="evenodd"
        d="M1.302 10.938c0-5.322 4.314-9.636 9.636-9.636 5.321 0 9.635 4.314 9.635 9.636a9.636 9.636 0 01-19.27 0zm9.636-8.073a8.073 8.073 0 100 16.146 8.073 8.073 0 000-16.146z"
        clipRule="evenodd"
      />
      <path
        fill={colors.primaryText}
        fillRule="evenodd"
        d="M10.938 7.031c.431 0 .78.35.78.782v6.25a.781.781 0 01-1.562 0v-6.25c0-.432.35-.782.781-.782z"
        clipRule="evenodd"
      />
      <path
        fill={colors.primaryText}
        fillRule="evenodd"
        d="M7.031 10.938c0-.432.35-.782.782-.782h6.25a.781.781 0 010 1.563h-6.25a.781.781 0 01-.782-.781zM16.75 16.75a.781.781 0 011.106 0l4.42 4.42a.781.781 0 11-1.106 1.105l-4.42-4.42a.781.781 0 010-1.104z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default SearchPlus
